function isValidTab(tab, allowedTabs) {
  return typeof tab === 'string' && Array.isArray(allowedTabs) && allowedTabs.includes(tab);
}

export function readPersistedTab(storageKey, allowedTabs, fallbackTab) {
  const normalizedFallback = isValidTab(fallbackTab, allowedTabs)
    ? fallbackTab
    : (Array.isArray(allowedTabs) ? allowedTabs[0] : '');

  if (!storageKey || typeof window === 'undefined') {
    return normalizedFallback;
  }

  try {
    const rawValue = window.localStorage.getItem(storageKey);
    if (!rawValue) {
      return normalizedFallback;
    }

    let storedValue = rawValue;
    try {
      const parsedValue = JSON.parse(rawValue);
      if (typeof parsedValue === 'string') {
        storedValue = parsedValue;
      }
    } catch {
      // Keep raw storage value for legacy plain-string keys.
    }

    return isValidTab(storedValue, allowedTabs) ? storedValue : normalizedFallback;
  } catch {
    return normalizedFallback;
  }
}

export function writePersistedTab(storageKey, tab, allowedTabs) {
  if (!storageKey || !isValidTab(tab, allowedTabs) || typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(storageKey, JSON.stringify(tab));
  } catch {
    // Ignore storage write failures.
  }
}
